import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useModal } from '../contexts/ModalContext';

const GlobalModal = () => {
    const { modalConfig, closeModal, handleConfirm } = useModal();

    if (!modalConfig) return null;

    const {
        type,
        title,
        message,
        variant = 'primary',
        onClose,
        confirmText,
        cancelText,
    } = modalConfig;

    const isConfirm = type === 'confirm';

    // Icon based on variant/type
    const getIcon = () => {
        if (variant === 'danger') return <i className="bi bi-exclamation-triangle-fill text-danger fs-1 mb-3"></i>;
        if (variant === 'warning') return <i className="bi bi-exclamation-circle-fill text-warning fs-1 mb-3"></i>;
        return <i className="bi bi-info-circle-fill text-primary fs-1 mb-3"></i>;
    };

    return (
        <Modal
            show={!!modalConfig}
            onHide={isConfirm ? closeModal : (onClose || closeModal)}
            centered
            backdrop="static"
            keyboard={false}
            className="modern-modal"
        >
            <Modal.Body className="text-center p-4">
                {getIcon()}
                <h5 className="fw-bold mb-2">{title}</h5>
                <p className="text-muted mb-4">{message}</p>
                <div className="d-flex justify-content-center gap-2">
                    {isConfirm && (
                        <Button
                            variant="light"
                            className="px-4 rounded-pill fw-bold text-secondary"
                            onClick={closeModal}
                        >
                            {cancelText || '취소'}
                        </Button>
                    )}
                    <Button
                        variant={variant}
                        className="px-4 rounded-pill fw-bold"
                        onClick={isConfirm ? handleConfirm : (onClose || closeModal)}
                    >
                        {confirmText || '확인'}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default GlobalModal;
